import classNames from "classnames";
import _, { toLower } from "lodash";
import { useEffect, useState } from "react";
import { formatCurrencyCountry } from "../../../../resources/internationalizationUtils";
import { useSelector } from "react-redux";

function PartnerSelectionListItem({
  selected = false,
  onClick,
  partnerList,
  isTitanAI = true,
}) {
  const [imageError, setImageError] = useState(false);

  const image = `https://s3.ap-south-1.amazonaws.com/uat-static.pidge.in/network/logo/${toLower(partnerList?.network_name)}_logo.svg`;

  const userDetails = useSelector((state) => state.app.user_details);
  const currency_code = userDetails?.currency || "DEFAULT";

  useEffect(() => {
    setImageError(false);
  }, [image]);

  return (
    <div
      onClick={onClick}
      className={classNames(
        "flex justify-between items-center py-6 px-5 bg-white rounded-lg cursor-pointer border border-1",
        selected
          ? "border-violet-600"
          : !isTitanAI
            ? "border-transparent shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)]"
            : "border-neutral-200",
      )}
    >
      <div
        className={`${isTitanAI ? "text-stone-500" : "text-stone-900"} text-xs font-bold min-w-[90px]`}
      >
        {partnerList?.network_name || "__"}
      </div>

      <span
        className={`${isTitanAI ? "text-stone-500" : "text-stone-900"} text-xs font-semibold`}
      >
        {partnerList?.quote?.price
          ? formatCurrencyCountry(partnerList.quote.price, currency_code)
              .formatedAmount
          : "__"}
      </span>

      {!imageError ? (
        <img
          key={image}
          src={image}
          alt={partnerList?.network_name}
          onError={() => setImageError(true)}
          className={`w-14 h-7 object-contain ${isTitanAI ? "grayscale" : ""}`}
        />
      ) : (
        <div
          className={`h-7 px-2 flex items-center justify-center text-xs font-medium rounded-[30px] ${
            isTitanAI ? "bg-[#C4C4C4]" : "bg-[#E4DCF3]"
          }`}
        >
          {partnerList?.network_name}
        </div>
      )}
    </div>
  );
}

export default PartnerSelectionListItem;
